import { Button } from "@chakra-ui/button";
import { Box, Flex, HStack, Stack, Text } from "@chakra-ui/layout";
import { faBookmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
} from "@chakra-ui/react";
import { useHistory } from "react-router";

// used to display in grid view
export const ProgramCard = ({ program }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);
  const initRef = useRef();
  const history = useHistory();

  const initSubscription = (id) => {
    history.push(`/dashboard/knowledge-bank/subscribe?programId=${id}`);
  };

  return (
    <>
      <Popover
        returnFocusOnClose={false}
        isOpen={isOpen}
        onClose={close}
        placement="right"
        closeOnBlur={true}
        initialFocusRef={initRef}
      >
        <PopoverTrigger>
          <Box
            sx={{
              borderRadius: "10px",
              boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
              cursor: "pointer",
            }}
            onClick={open}
          >
            <Box
              sx={{
                height: "225px",
                backgroundColor: "#c4c4c4",
                backgroundImage: `url('${program.imgSrc}')`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                borderRadius: "10px 10px 0 0",
              }}
            ></Box>

            <Box p={8}>
              <Flex justify="space-between">
                {/* program title */}
                <Text sx={{ fontWeight: "600", fontSize: "20px" }}>
                  {program.title}
                </Text>

                <Box sx={{ color: "#223D5D" }} mt="1">
                  <FontAwesomeIcon icon={faBookmark} />
                </Box>
              </Flex>

              <Box mt="2">
                <Text sx={{ color: "#89969F" }}>{program.instructor}</Text>
              </Box>
            </Box>
          </Box>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverHeader fontWeight="semibold">
            <Flex justify="space-between" align="center" mt="6">
              <Text> {program.title} </Text>
              {/* program price */}
              <Text sx={{ color: "#00A2E7", fontSize: "24px" }}>
                {program.duration[0].price}
              </Text>
            </Flex>
          </PopoverHeader>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody>
            {/* summary */}
            <Text mt="4">{program.summary}</Text>

            <Box my="6">
              <Stack gap="4">
                <HStack gap="4" alignItems="top">
                  <FontAwesomeIcon icon={faCheck} />
                  <Text>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                  </Text>
                </HStack>

                <HStack gap="4" alignItems="top">
                  <FontAwesomeIcon icon={faCheck} />
                  <Text>Lorem ipsum dolor sit amet</Text>
                </HStack>

                <HStack gap="4" alignItems="top">
                  <FontAwesomeIcon icon={faCheck} />
                  <Text>
                    Lorem ipsum dolor sit amet, ctetur adipiscing elit,
                    consectetur adipiscing elit
                  </Text>
                </HStack>
              </Stack>
            </Box>
          </PopoverBody>
          <PopoverFooter d="flex" justifyContent="flex-end">
            <Button
              ref={initRef}
              isFullWidth
              bg="#00A2E8"
              color="#FFFFFF"
              onClick={() => initSubscription(program._id)}
            >
              Subscribe
            </Button>
          </PopoverFooter>
        </PopoverContent>
      </Popover>
    </>
  );
};

// used to display in list view
export const ProgramList = ({ program }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);
  const initRef = useRef();

  const history = useHistory();

  const initSubscription = (id) => {
    history.push(`/dashboard/knowledge-bank/subscribe?programId=${id}`);
  };

  return (
    <>
      <Box
        sx={{
          borderRadius: "10px",
          cursor: "pointer",
          border: "1px solid #F6F7FB",
        }}
        onClick={open}
      >
        <Box
          sx={{
            width: "100%",
          }}
        ></Box>

        <Box p={8}>
          <Flex justify="space-between">
            <Flex align="center">
              {/* program title */}
              <Text sx={{ fontWeight: "600", fontSize: "20px" }}>
                {program.title}
              </Text>
              <Text ml="12" sx={{ color: "#89969F" }}>
                {program.instructor}
              </Text>

              <Box>
                <Popover
                  returnFocusOnClose={false}
                  isOpen={isOpen}
                  onClose={close}
                  placement="right"
                  closeOnBlur={true}
                  initialFocusRef={initRef}
                >
                  <PopoverTrigger>
                    <Box></Box>
                  </PopoverTrigger>
                  <PopoverContent>
                    <PopoverHeader fontWeight="semibold">
                      <Flex justify="space-between" align="center" mt="6">
                        <Text> {program.title} </Text>
                        {/* program price */}
                        <Text sx={{ color: "#00A2E7", fontSize: "24px" }}>
                          {program.duration[0].price}
                        </Text>
                      </Flex>
                    </PopoverHeader>
                    <PopoverArrow />
                    <PopoverCloseButton />
                    <PopoverBody>
                      {/* summary */}
                      <Text mt="4">{program.summary}</Text>

                      <Box my="6">
                        <Stack gap="4">
                          <HStack gap="4" alignItems="top">
                            <FontAwesomeIcon icon={faCheck} />
                            <Text>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit
                            </Text>
                          </HStack>

                          <HStack gap="4" alignItems="top">
                            <FontAwesomeIcon icon={faCheck} />
                            <Text>Lorem ipsum dolor sit amet</Text>
                          </HStack>

                          <HStack gap="4" alignItems="top">
                            <FontAwesomeIcon icon={faCheck} />
                            <Text>
                              Lorem ipsum dolor sit amet, ctetur adipiscing
                              elit, consectetur adipiscing elit
                            </Text>
                          </HStack>
                        </Stack>
                      </Box>
                    </PopoverBody>
                    <PopoverFooter d="flex" justifyContent="flex-end">
                      <Button
                        ref={initRef}
                        isFullWidth
                        bg="#00A2E8"
                        color="#FFFFFF"
                        onClick={() => initSubscription(program._id)}
                      >
                        Subscribe
                      </Button>
                    </PopoverFooter>
                  </PopoverContent>
                </Popover>
              </Box>
            </Flex>

            <Box sx={{ color: "#223D5D" }} mt="1">
              <FontAwesomeIcon icon={faBookmark} />
            </Box>
          </Flex>
        </Box>
      </Box>
    </>
  );
};
